import './AccountPage.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageContentWrapper from 'src/components/PageContentWrapper/PageContentWrapper';
import { useTheme } from 'src/provider/ThemeProvider';
import { useLoader } from 'src/provider/LoaderProvider';
import { useGetAccountsQuery } from 'src/services/accountsService';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { ACCOUNT_ACCESS_ROLES } from 'src/constants/roles';
import { PATH_HOME } from 'src/constants/spa-routes';
import { UserInfoCard } from './components/UserInfoCard';
import { CompanyInfoCard } from './components/CompanyInfoCard';
import { TeamCard } from './components/TeamCard';
import { useCardEditCoordinator } from './hooks/useCardEditCoordinator';

const AccountPage = () => {
  const navigate = useNavigate();
  const { setTheme } = useTheme();
  const loader = useLoader();

  const { data: account, isFetching: isAccountFetching } = useGetAccountsQuery();
  const { data: userInfo } = useGetUsersMeQuery();

  const { isEditing, isDisabled, startEditing, stopEditing } = useCardEditCoordinator();
  const [isUserSaving, setIsUserSaving] = useState(false);
  const [isCompanySaving, setIsCompanySaving] = useState(false);

  useEffect(() => {
    setTheme('green');
  }, []);

  useEffect(() => {
    if (userInfo && !ACCOUNT_ACCESS_ROLES.includes(userInfo.role)) {
      navigate(PATH_HOME.ROOT);
    }
  }, [userInfo]);

  useEffect(() => {
    if (isAccountFetching || isUserSaving || isCompanySaving) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isAccountFetching, isUserSaving, isCompanySaving]);

  return (
    <PageContentWrapper className="account-page-container">
      <div className="flex md:flex-row flex-col gap-0.625-rem">
        <UserInfoCard
          userInfo={userInfo}
          editMode={isEditing('user')}
          disabled={isDisabled('user')}
          onEdit={() => startEditing('user')}
          onDone={stopEditing}
          onLoadingChange={setIsUserSaving}
        />
        <CompanyInfoCard
          account={account}
          editMode={isEditing('company')}
          disabled={isDisabled('company')}
          onEdit={() => startEditing('company')}
          onDone={stopEditing}
          onLoadingChange={setIsCompanySaving}
        />
      </div>
      <TeamCard userInfo={userInfo} disabled={isDisabled('team')} />
    </PageContentWrapper>
  );
};

export default AccountPage;
